import React from 'react';
import './Footer.css';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';

// Reusable component for social media icons
const SocialIcon = ({ href, Icon }) => (
    <a href={href} target="_blank" rel="noopener noreferrer" className="social-icon">
        <Icon />
    </a>
);

const Footer = () => {
    return (
        <footer className="footer">
            {/* Links section */}
            <div className="footer-links">
                <a href="/privacy-policy" className="footer-link">Privacy Policy</a>
                <a href="/terms-and-conditions" className="footer-link">Terms and Conditions for Reporters</a>
                <a href="/payment-policy" className="footer-link">Payment Policy for Reporters</a>
                <a href="/user-terms" className="footer-link">Terms and Conditions</a>
                <a href="/governing-law-and-jurisdiction" className="footer-link">Advertise</a>
            </div>
            
            {/* Social icons section */}
            <div className="social-icons">
                <SocialIcon href="https://facebook.com" Icon={FaFacebook} />
                <SocialIcon href="https://twitter.com" Icon={FaTwitter} />
                <SocialIcon href="https://instagram.com" Icon={FaInstagram} />
                <SocialIcon href="https://linkedin.com" Icon={FaLinkedin} />
            </div>

            {/* Animated Buttons Section */}
            <div className="footer-buttons">
                <a href="/reporter/login" className="footer-button reporter-button">
                    Become a Reporter
                </a>
                <a href="/advertise" className="footer-button advertise-button">
                    Advertise With Us
                </a>
            </div>

            {/* Footer bottom section */}
            <div className="footer-bottom">
                <p>&copy; 2024 Today Local. All rights reserved.</p>
                <p>Designed by <a href="https://softyetech.com/" target="_blank" rel="noopener noreferrer">Softye Technologies</a></p>
            </div>
        </footer>
    );
};

export default Footer;
